module.exports = __webpack_public_path__ + "matrixagdrtv.png?5fb127d6218d0d73cd11666c0627aaae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/matrixagdrtv.png
// module id = 978
// module chunks = 2